import classNames from 'classnames';
import { Block, LiveBlockAddress } from '../types';
import { LineGroupView } from './LineGroupView';
import { BlockWrapper } from './wrappers';

type BlockViewProps = {
  block: Block,
  descriptor: string,
  liveAddress?: LiveBlockAddress,
  onLineClick?: (lineGroupIdx: number) => (lineIdx: number) => void
}

export const BlockView = ({ block, descriptor, liveAddress, onLineClick }: BlockViewProps) => {

  const wrapperClasses = classNames(
    {
      'border-transparent': !liveAddress,
      'border-blue-900': !!liveAddress
    }
  );

  return (
    <BlockWrapper
      blockType={block.type}
      className={wrapperClasses}
      descriptor={descriptor}
    >
      {
          block.content.map(
            (lineGroup, idx) => (
              <LineGroupView
                key={idx}
                lineGroup={lineGroup}
                liveAddress={liveAddress && liveAddress.group === idx ? liveAddress : undefined}
                onLineClick={onLineClick && onLineClick(idx)}
              />
            )
          )
        }
    </BlockWrapper>
  );
};
